// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"AuctionGrid_gridContainer__2xgc2"};